/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Who_3Inputs */

const en_mk_abt_who_3 = /** @type {(inputs: Mk_Abt_Who_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are a small team and we do not pretend otherwise. If you write to us, the person who answers is the person who wrote the code.`)
};

const id_mk_abt_who_3 = /** @type {(inputs: Mk_Abt_Who_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami tim kecil, dan kami tidak berpura-pura sebaliknya. Kalau Anda menulis kepada kami, yang menjawab adalah orang yang menulis kodenya.`)
};

/**
* | output |
* | --- |
* | "We are a small team and we do not pretend otherwise. If you write to us, the person who answers is the person who wrote the code." |
*
* @param {Mk_Abt_Who_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_who_3 = /** @type {((inputs?: Mk_Abt_Who_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Who_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_who_3(inputs)
	return en_mk_abt_who_3(inputs)
});